import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'redux/store';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import Loader from 'components/common/Loader/Loader';

export const persistor = persistStore(store);

const root = createRoot(document.getElementById('root') as HTMLElement)!;

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Loader />
      <App />
    </PersistGate>
  </Provider>,
);
